import { createClient } from './http';

const SEARCH_API_BASE = import.meta.env.VITE_SEARCH_API_BASE_URL ?? 'https://x-gis.xenus.dev/api/search';

const request = createClient(SEARCH_API_BASE);

export type SearchHit = {
  layer_id: string;
  layer_name: string;
  feature_id: string;
  attributes: Record<string, unknown>;
  geometry: { type: string; coordinates?: unknown } | null;
  score: number;
};

export type SearchResponse = {
  query: string;
  total: number;
  hits: SearchHit[];
};

export type ReindexResponse = {
  indexed_features: number;
  layers_indexed: number;
};

export type AddressHit = {
  osm_id: number;
  display_address: string;
  street: string | null;
  housenumber: string | null;
  city: string | null;
  geometry: { type: string; coordinates?: unknown } | null;
  score: number;
};

export type AddressSearchResponse = {
  query: string;
  total: number;
  hits: AddressHit[];
};

export const searchApi = {
  searchObjects: (q: string, limit = 20) =>
    request<SearchResponse>(`/objects?q=${encodeURIComponent(q)}&limit=${limit}`, {}, true),

  /** Global (not per-workspace) — Rosreestr/OSM address data, same for every
   * workspace. Empty results just mean nothing matched, same failure shape as
   * searchObjects — the caller doesn't need to know this hits a different
   * index under the hood. `near`, when given, re-ranks hits by distance from
   * that point (current map center) — closer wins, text relevance still applies. */
  searchAddresses: (q: string, limit = 20, near?: { lat: number; lon: number }) => {
    const params = new URLSearchParams({ q, limit: String(limit) });
    if (near) {
      params.set('lat', String(near.lat));
      params.set('lon', String(near.lon));
    }
    return request<AddressSearchResponse>(`/addresses?${params.toString()}`, {}, true);
  },

  reindex: () => request<ReindexResponse>('/reindex', { method: 'POST' }, true),
};
